import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

export type MapAction =
    | 'zoom-in'
    | 'zoom-out'
    | 'reset'
    | 'draw'
    | 'view'
    | 'undo'
    | 'redo'
    | 'delete';
/**
 * A service responsible for managing emitted events from component and relying that event to the compnent that subscribes to this Subject
 *
 * @remarks
 * Used in custom controls component to indirectly communicate with the territory map
 */
@Injectable({
    providedIn: 'root',
})
export class MapControlsService {
    /**
     * Subject to emit map actions
     */
    private actionSubject = new Subject<MapAction>();

    /**
     * Observable to listen to map actions
     */
    public readonly action$ = this.actionSubject.asObservable();

    /**
     * Emit view action
     */
    public view() {
        this.actionSubject.next('view');
    }

    /**
     * Emit draw action
     */
    public draw() {
        this.actionSubject.next('draw');
    }

    /**
     * Emit zoom in action
     */
    public zoomIn() {
        this.actionSubject.next('zoom-in');
    }

    /**
     * Emit zoom out action
     */
    public zoomOut() {
        this.actionSubject.next('zoom-out');
    }

    /**
     * Emit reset action — restores the initial map center/zoom
     */
    public reset() {
        this.actionSubject.next('reset');
    }

    /**
     * Emit undo action
     */
    public undo() {
        this.actionSubject.next('undo');
    }

    /**
     * Emit redo action
     */
    public redo() {
        this.actionSubject.next('redo');
    }

    /**
     * Emit delete action
     */
    public delete() {
        this.actionSubject.next('delete');
    }
}
